import { MOBILE_BREAKPOINT_THRESHOLD, styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Container, ContainerCssTokens } from '@youhelp-ru/ui';
import { Grid } from '@cp/ds/src/components/grid';
import { GridProps } from '@cp/ds/src/components/grid/model';
import React, { ComponentType } from 'react';
import { ChecksBanner } from './components/checksBanner';
import { VideoBanner } from './components/videoBanner';

const banners: React.FC[] = [ChecksBanner, VideoBanner];

const Root = styled(Box, { name: 'HomeBanners' })(({ theme }) => ({
  backgroundColor: theme.palette['gray ultra light'],
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    [ContainerCssTokens.width]: '1430px',
  },
  [theme.breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD)]: {
    [ContainerCssTokens.offset]: 0,
  },
})) as unknown as ComponentType<BoxProps>;

export const HomeBanners: React.FC = () => {
  const gridItemProps: GridProps = {
    size: {
      xs: 12,
      [MOBILE_BREAKPOINT_THRESHOLD]: 6,
    },
    sx: {
      flexGrow: '1!important',
      minHeight: { [MOBILE_BREAKPOINT_THRESHOLD]: 338 },
      maxWidth: { [MOBILE_BREAKPOINT_THRESHOLD]: 800 },
    },
  };

  return (
    <Root
      sx={{
        pt: { xs: 0, [MOBILE_BREAKPOINT_THRESHOLD]: 10 },
        pb: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 2.5 },
      }}
    >
      <Container>
        <Grid alignItems="stretch" container justifyContent="center" spacing={{ xs: 1.25, [MOBILE_BREAKPOINT_THRESHOLD]: 4.5 }} wrap="wrap">
          {banners.map((Banner, index) => (
            <Grid key={index} {...gridItemProps}>
              <Banner />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Root>
  );
};
